export const API_GET_VOUCHER_NOAUTHORIZED = "/comprobantes/noautorizados/";

export const API_GET_SEARCH_NOAUTHORIZED = `/comprobantes/noautorizados/busqueda/`;